/** Shared card-accent palette (left-border color) — keeps Tasks/Scheduled Tasks/Agents cards visually consistent. */
export const ACCENT_COLORS = {
    purple: '#7c3aed',
    pink: '#db2777',
    blue: '#2563eb',
    gray: '#64748b',
    green: '#059669',
    orange: '#d97706',
};
/** Card sx shared by Tasks/Scheduled Tasks/Agents boards: white bg, colored left border, subtle hover. */
export function accentCardSx(accent, opts = {}) {
    const { selected = false, dimmed = false, multiSelected = false } = opts;
    return {
        mb: 1,
        borderLeft: '3px solid',
        borderLeftColor: accent,
        bgcolor: selected || multiSelected ? '#e9f2ff' : '#fff',
        opacity: dimmed ? 0.7 : 1,
        transition: 'background-color 0.1s ease, box-shadow 0.1s ease',
        ...(multiSelected && { outline: '2px solid #0052cc', outlineOffset: '-1px' }),
        '&:hover': {
            bgcolor: selected || multiSelected ? '#e9f2ff' : '#f7f8f9',
            boxShadow: '0 1px 3px rgba(9,30,66,0.13)',
        },
    };
}
